import { useEffect, useState } from "react";
import api, { formatApiError, money } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/common";
import { TransactionHistory } from "@/components/TransactionHistory";
import { toast } from "sonner";
import { Wallet } from "@phosphor-icons/react";

export default function AccountBilling() {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/billing/balance");
        setBalance(data.cash_balance_minor || 0);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="account-billing-page">
      <PageHeader title="Billing"
        subtitle="Your cash balance and full transaction history. Cash is credited when a payment request is approved." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <StatCard testid="billing-balance" icon={Wallet} tone="success"
          label="Cash Balance" value={loading ? "…" : money(balance)}
          hint="Available cash for concurrent-channel purchases" />
      </div>
      <TransactionHistory />
    </div>
  );
}
